// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Preact from "../bindings/Preact.js";
import * as GunHelpers from "../lib/GunHelpers.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

function Display(props) {
  let storeId = props.storeId;
  let match = React.useState(() => {});
  let setStore = match[1];
  let store = match[0];
  let match$1 = React.useState(() => true);
  let setIsLoading = match$1[1];
  let match$2 = React.useState(() => {});
  let setError = match$2[1];
  let error = match$2[0];
  let unsubscribeRef = React.useRef(undefined);
  let loadStore = async () => {
    try {
      let storeData = await GunHelpers.getStore(storeId, undefined);
      if (storeData !== undefined) {
        setStore(param => storeData);
      } else {
        setError(param => "Queue not found");
      }
    } catch (raw_err) {
      let err = Primitive_exceptions.internalToException(raw_err);
      if (err.RE_EXN_ID === "JsExn") {
        console.error(err._1);
        setError(param => "Failed to load queue");
      } else {
        throw err;
      }
    }
    return setIsLoading(param => false);
  };
  React.useEffect(() => {
    GunHelpers.initGun(undefined);
    loadStore();
    return () => {
      let unsub = unsubscribeRef.current;
      if (unsub !== undefined) {
        return unsub();
      }
    };
  }, []);
  React.useEffect(() => {
    if (store === undefined) {
      return;
    }
    let unsub = GunHelpers.subscribeToStore(storeId, updatedStore => setStore(param => updatedStore));
    unsubscribeRef.current = unsub;
    return () => {
      unsub();
      unsubscribeRef.current = undefined;
    };
  }, [Stdlib_Option.isSome(store)]);
  if (match$1[0]) {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("div", {
        children: "Loading...",
        className: "loading"
      }),
      className: "page display-page",
      "data-testid": "display-page"
    });
  }
  if (error !== undefined && store === undefined) {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("h1", {
            children: "Display",
            className: "page-title"
          }),
          className: "page-header"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("p", {
              children: error
            }),
            className: "error",
            "data-testid": "display-error"
          }),
          className: "container"
        })
      ],
      className: "page display-page",
      "data-testid": "display-page"
    });
  }
  if (store !== undefined) {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("h1", {
            children: store.name,
            className: "page-title",
            "data-testid": "store-name"
          }),
          className: "page-header"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                  children: store.nowServing > 0 ? "Now Serving" : "Waiting for first customer",
                  className: "display-label"
                }),
                store.nowServing > 0 ? JsxRuntime.jsx("div", {
                    children: `#` + store.nowServing.toString(),
                    className: "display-number",
                    "data-testid": "now-serving-number"
                  }) : null
              ],
              className: "display-now-serving",
              "data-testid": "now-serving-display"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("span", {
                      children: "Next Number",
                      className: "stat-label"
                    }),
                    JsxRuntime.jsx("span", {
                      children: `#` + (store.currentNumber + 1 | 0).toString(),
                      className: "stat-value",
                      "data-testid": "next-number"
                    })
                  ],
                  className: "stat-item"
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("span", {
                      children: "Served Today",
                      className: "stat-label"
                    }),
                    JsxRuntime.jsx("span", {
                      children: store.servedToday.toString(),
                      className: "stat-value",
                      "data-testid": "served-today"
                    })
                  ],
                  className: "stat-item"
                })
              ],
              className: "display-stats mt-4"
            })
          ],
          className: "container"
        })
      ],
      className: "page display-page",
      "data-testid": "display-page"
    });
  } else {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("div", {
        children: "Loading...",
        className: "loading"
      }),
      className: "page display-page",
      "data-testid": "display-page"
    });
  }
}

function expose() {
  Preact.setWindowProperty("Display", Display);
}

let make = Display;

export {
  make,
  expose,
}
/* react Not a pure module */
